/**
 * WordPress dependencies.
 */
import { __ } from "@wordpress/i18n";
import { Placeholder, Spinner } from "@wordpress/components";
import { StrictMode, Fragment } from "@wordpress/element";

/**
 * Internal dependencies.
 */
import Header from "./Header.js";
import GeneralOption from "./GeneralOption.js";
import PageSpeed from "./page-speed.js";
import Debug from "./Debug.js";
import Sidebar from "./Sidebar.js";
import { ServiceBanner } from "./helpers-functions.js";

const Main = ({ currentTab, setTab, settings }) => {

	const [getOption, updateOption, status, isAtive] = settings();

	if ("loading" === status) {
		return (
			<Placeholder>
				<Spinner />
			</Placeholder>
		);
	}

	const Content = ( ) => {
		switch (currentTab) {
			case "speed-test":
				return ( <PageSpeed /> );
			case "debug":
				return ( <Debug /> );
			case "general":
				return ( <GeneralOption status={status} getOption={getOption} updateOption={updateOption} /> );
		}
	};

	return (
		<StrictMode>
		<Fragment>
			<Header setActive={setTab} isAtive={isAtive} />
			{window.ahscUtils.const.servCheck.notice !== null && (
				<ServiceBanner notice={window.ahscUtils.const.servCheck.notice} />
			)}
			<div className={`ahsc-main is-${currentTab}`}>
				<div className="ahsc-left"><Content /></div>
				<div className="ahsc-right">
					<Sidebar />
				</div>
			</div>
		</Fragment>
		</StrictMode>
	);
};

export default Main;
